const resizeImage = (imageUrl, size) => {
  const urlSplit = imageUrl.split('/');
  urlSplit.splice(3, 0, `fit-in/${size}x${size}`);
  return urlSplit.join('/');
};

export default resizeImage;
